import UpgradeAccountError from './UpgradeAccountError';
class InvestorNotFound extends UpgradeAccountError {
    constructor(options) {
        super('Investor was not found', options);
    }
}
export default InvestorNotFound;
